import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { basePath as adminBasePath } from './admin/routes/routes';
import { basePath as brandBasePath } from './brand/routes/routes';
import { isFirebaseAuthenticatedGuard } from './core/auth/is-firebase-authenticated.guard';
import { redirectIfAuthenticatedGuard } from './core/auth/redirect-if-authenticated.guard';
import { EmailLinkLoginPage } from './core/pages/email-link-login-page/email-link-login-page.component';
import { LoginPageComponent } from './core/pages/login-page/login-page.component';
import { NotfoundPageComponent } from './core/pages/notfound-page/notfound-page.component';
import { OnboardingBrandPageComponent } from './core/pages/onboarding-brand-page/onboarding-brand-page.component';
import { OnboardingCreatorPageComponent } from './core/pages/onboarding-creator-page/onboarding-creator-page.component';
import { OnboardingPageComponent } from './core/pages/onboarding-page/onboarding-page.component';
import { TermsConditionsPageComponent } from './core/pages/terms-conditions-page/terms-conditions-page.component';
import { UserInvitationLoginPageComponent } from './core/pages/user-invitation-login-page/user-invitation-login-page.component';
import { WelcomeBrandPageComponent } from './core/pages/welcome-brand-page/welcome-brand-page.component';
import { WelcomeCreatorPageComponent } from './core/pages/welcome-creator-page/welcome-creator-page.component';
import { routes } from './core/routes/routes';
import { basePath as creatorBasePath } from './creator/routes/routes';
import { basePath as editorBasePath } from './editor/routes/routes';

const r: Routes = [
  {
    path: '',
    redirectTo: routes.login.path,
    pathMatch: 'full',
  },
  {
    path: routes.userInvitationLogin.path,
    component: UserInvitationLoginPageComponent,
    canActivate: [redirectIfAuthenticatedGuard],
  },
  {
    path: routes.login.path,
    component: LoginPageComponent,
    canActivate: [redirectIfAuthenticatedGuard],
  },
  {
    path: routes.emailLinkLogin.path,
    component: EmailLinkLoginPage,
    canActivate: [redirectIfAuthenticatedGuard],
  },
  {
    path: routes.termsAndConditions.path,
    component: TermsConditionsPageComponent,
  },
  {
    path: routes.onboarding.index.path,
    component: OnboardingPageComponent,
    canActivate: [isFirebaseAuthenticatedGuard()],
  },
  {
    path: routes.onboarding.creator.path,
    component: OnboardingCreatorPageComponent,
    canActivate: [isFirebaseAuthenticatedGuard()],
  },
  {
    path: routes.onboarding.brand.path,
    component: OnboardingBrandPageComponent,
    canActivate: [isFirebaseAuthenticatedGuard()],
  },
  {
    path: routes.welcome.brand.path,
    component: WelcomeBrandPageComponent,
    canActivate: [isFirebaseAuthenticatedGuard()],
  },
  {
    path: routes.welcome.creator.path,
    component: WelcomeCreatorPageComponent,
    canActivate: [isFirebaseAuthenticatedGuard()],
  },
  {
    path: creatorBasePath,
    loadChildren: () => import('./creator/creator.module').then(m => m.CreatorModule),
  },
  {
    path: brandBasePath,
    loadChildren: () => import('./brand/brand.module').then(m => m.BrandModule),
  },
  {
    path: adminBasePath,
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: editorBasePath,
    loadChildren: () => import('./editor/editor.module').then(m => m.EditorModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotfoundPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(r, {
      bindToComponentInputs: true,
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
